import { PaisMercadoGlobalEnum } from '../types/enums/pais-mercado-global.enum';

export const documentMasks: Record<PaisMercadoGlobalEnum, string> = {
  [PaisMercadoGlobalEnum.BRA]: '999.999.999-99',
  [PaisMercadoGlobalEnum.EUA]: '999-99-9999',
  [PaisMercadoGlobalEnum.CAN]: '999-999-999',
  [PaisMercadoGlobalEnum.CHL]: '99.999.999-K',
  [PaisMercadoGlobalEnum.PRY]: '9999999-9',
  [PaisMercadoGlobalEnum.PER]: '99999999',
  [PaisMercadoGlobalEnum.COL]: '9999999999',
  [PaisMercadoGlobalEnum.MEX]: 'AAAA999999AAAAAA99',
  [PaisMercadoGlobalEnum.JPN]: '9999-9999-9999',
  [PaisMercadoGlobalEnum.GBR]: 'AA 99 99 99 A',
  [PaisMercadoGlobalEnum.DEU]: '99999999999',
  [PaisMercadoGlobalEnum.FRA]: '9 99 99 99 999 999 99',
  [PaisMercadoGlobalEnum.ESP]: '99999999A',
  [PaisMercadoGlobalEnum.ITA]: 'AAAAAA99A99A999A',
  [PaisMercadoGlobalEnum.NLD]: '999999999',
  [PaisMercadoGlobalEnum.POL]: '99999999999',
  [PaisMercadoGlobalEnum.BEL]: '99.99.99-999.99',
  [PaisMercadoGlobalEnum.SWE]: '99999999-9999',
  [PaisMercadoGlobalEnum.DNK]: '999999-9999',
  [PaisMercadoGlobalEnum.NOR]: '99999999999',
  [PaisMercadoGlobalEnum.FIN]: '999999X999U',
  [PaisMercadoGlobalEnum.AUT]: '999999999',
  [PaisMercadoGlobalEnum.IRL]: '9999999A',
  [PaisMercadoGlobalEnum.PRT]: '999999999',
  [PaisMercadoGlobalEnum.CHE]: '999.999.999',
  [PaisMercadoGlobalEnum.LUX]: '9999999999999',
  [PaisMercadoGlobalEnum.MCO]: '9999999',
};
